<ul class="menu-nav" [ngClass]="ulCSSClasses">
  <li class="menu-item menu-item-rel" [ngClass]="{ 'menu-item-here': isInPracticeArea() }">
    <span class="menu-link" (click)="navigateToContestList('/problem/list')">
      <span class="menu-text">{{ '::Practice' | abpLocalization }}</span>
    </span>
  </li>

  <li class="menu-item menu-item-rel" [ngClass]="{ 'menu-item-here': isInContestArea() }">
    <span class="menu-link" (click)="navigateToContestList('/contest/list')">
      <span class="menu-text">{{ '::Contest' | abpLocalization }}</span>
    </span>
  </li>

  <li class="menu-item menu-item-rel" [ngClass]="{ 'menu-item-here': isInTrainingArea() }">
    <span class="menu-link" (click)="navigateToContestList('/training')">
      <span class="menu-text">{{ '::Training' | abpLocalization }}</span>
    </span>
  </li>

  <li class="menu-item menu-item-rel" [ngClass]="{ 'menu-item-here': isInGeneralLeadboardArea() }">
    <span class="menu-link" (click)="navigateToContestList('/leaderboard')">
      <span class="menu-text">{{ '::Leaderboard' | abpLocalization }}</span>
    </span>
  </li>

  <li class="menu-item menu-item-rel" *abpPermission="'AbpIdentity.Roles'">
    <a class="menu-link" mat-button [matMenuTriggerFor]="administration">
      <span class="menu-text">{{ 'AbpUiNavigation::Menu:Administration' | abpLocalization }}</span>
    </a>

    <mat-menu #administration="matMenu">
      <button mat-menu-item [matMenuTriggerFor]="IdentityManagement">
        {{ 'AbpIdentity::Menu:IdentityManagement' | abpLocalization }}
      </button>
      <button mat-menu-item [matMenuTriggerFor]="TenantManagement">
        {{ 'AbpTenantManagement::Menu:TenantManagement' | abpLocalization }}
      </button>
    </mat-menu>

    <mat-menu #IdentityManagement="matMenu">
      <button mat-menu-item routerLink="/identity/roles">
        {{ 'AbpIdentity::Roles' | abpLocalization }}
      </button>
      <button mat-menu-item routerLink="/identity/users">
        {{ 'AbpIdentity::Users' | abpLocalization }}
      </button>
    </mat-menu>

    <mat-menu #TenantManagement="matMenu">
      <button mat-menu-item routerLink="/tenant-management/tenants">
        {{ 'AbpTenantManagement::Tenants' | abpLocalization }}
      </button>
    </mat-menu>
  </li>

  <li *ngFor="let page of headerPages" class="menu-item menu-item-rel">
    <span class="menu-link" [routerLink]="'/page/' + page.slug">
      <span class="menu-text" [innerText]="page.name"></span>
    </span>
  </li>
</ul>
